import popupFooterComponent from './popupFooter.component';

const popupFooterModule = angular.module('app.common.ertPopupFooter', [])
	.component('ertPopupFooter', popupFooterComponent)
	.name;

export default popupFooterModule;
